import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/** Ein/Aus-Schalter der KI-Einstellungen (page-ki-einstellungen.jsx:3-10). */
@Component({
  selector: 'app-ki-switch',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      role="switch"
      class="ki-switch"
      [class.ki-switch--an]="an()"
      [attr.aria-checked]="an()"
      [attr.aria-label]="label()"
      [attr.data-testid]="testId()"
      [disabled]="disabled()"
      (click)="geaendert.emit(!an())"
    >
      <span class="ki-switch__knopf" aria-hidden="true"></span>
    </button>
  `,
  styles: `
    :host {
      display: inline-flex;
      flex-shrink: 0;
    }

    .ki-switch {
      position: relative;
      width: 2.5rem;
      height: 1.375rem;
      padding: 0;
      border: none;
      border-radius: 50rem;
      background: var(--to-control-unselected);
      cursor: pointer;
      transition: background 0.15s;
    }

    .ki-switch--an {
      background: var(--to-brand);
    }

    .ki-switch:disabled {
      background: var(--to-border-soft);
      cursor: not-allowed;
    }

    .ki-switch:focus-visible {
      outline: 2px solid var(--to-focus-ring);
      outline-offset: 2px;
    }

    .ki-switch__knopf {
      position: absolute;
      top: 0.1875rem;
      left: 0.1875rem;
      width: 1rem;
      height: 1rem;
      border-radius: 50rem;
      background: var(--to-card);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
      transition: left 0.15s;
    }

    .ki-switch--an .ki-switch__knopf {
      left: 1.3125rem;
    }
  `,
})
export class KiSwitchComponent {
  readonly an = input.required<boolean>();
  readonly label = input.required<string>();
  readonly testId = input<string | null>(null);
  readonly disabled = input(false);

  readonly geaendert = output<boolean>();
}
